import { useEffect, useState } from 'react';

import { generateColorList } from "../../../utils/colors";

export const useChart = (
  data,
  options = {
    shouldUpdateTotal: true,
    colorsOffset: 0
  }
) => {
  const [hiddenFields, setHiddenFields] = useState({});
  const [adaptedData, setAdaptedData] = useState([]);
  const [colors, setColors] = useState([]);

  const toggleBarVisibility = (dataKey) => {
    setHiddenFields((prevState)=> {
      return {...prevState, [dataKey]: !prevState[dataKey]};
    });
  };

  const getColors = () => {
    const startingColor = "#61A2A5"; // TODO: Agafa el color primary, posa una prop que es digui bar mainColor per el component
    // INFO: This generates a list of colors based on the starting color and the number of elements
    let colors = generateColorList(startingColor, data.magnitudes.elements.length);
    let colorsOffset = options.colorsOffset;
    // INFO: If colorsOffset is not set or it's less than or equal to 0, set it to 1
    if (!colorsOffset || colorsOffset <= 0) {
      colorsOffset = 1;
    }
    // INFO: This filters the list of colors to only include those at positions 
    // that are multiples of colorsOffset (basically, it skips some colors based on the offset)
    colors = colors.filter((_, index) => index % colorsOffset === 0);
    return colors;
  };

  const updateTotal = () => {
    setAdaptedData(
      //Per cada mes o dia
      data.curve.map(date => {

        let newTotal = 0;
        Object.entries(date).forEach(component => {
          let componentName = component[0];

          // Si el camp no està amagat es suma al total
          if (!hiddenFields[componentName]) {
            if (Number(component[1])) {
              newTotal += component[1];
            }
          }
        });

        return {...date, "total": Math.round((newTotal + Number.EPSILON) * 100) / 100};
      })
    );
  };

  useEffect(() => {
    setColors(getColors());
  }, [data]);

   useEffect(() => {
    options.shouldUpdateTotal && updateTotal();
  }, [data, hiddenFields]);

  return { colors, hiddenFields, adaptedData, toggleBarVisibility };
}
